import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from './Service/auth.service';
import { UserService } from './User/Service/user.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { NavigationEnd, Router } from '@angular/router';
import { LoggingService } from './Service/logging.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  constructor(
    public auth: AuthService,
    public userService: UserService,
    // public loadingService: LoadingService,
    public router: Router,
    private readonly logging: LoggingService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.logging.logPageView(event.url, event.url);
      }
    });
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  title = 'Family Central';

  ngOnInit() {
    this.subscriptions.add(
      this.auth.userProfileSubject$.subscribe((resp) => {
        if (resp != null) {
          if (resp.email) {
            this.userService.isLoggedin = true;
            this.userService.authUserInfo = resp;
            this.userService.isLoggedin$.next(true);
          } else {
            this.userService.loginVerified = true;
            this.userService.isLoggedin$.next(false);
          }
          this.userService.loginVerified = true;
        }
      })
    );
  } 
}
